//Primera letra mayuscula
export function primerMayuscula(texto) {
	return texto.charAt(0).toUpperCase() + texto.slice(1);
}
